import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import Shimmer from "react-shimmer-effect";
import { Redirect } from "react-router-dom"

import { Row, Col } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService"

import DetailDataTableBloc from '../Blocs/DetailDataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import moment from 'moment'

class DetailTableActiveComponent extends Component {
    detailDataTableBloc = new DetailDataTableBloc();

    source
    historyTable = 'historylaporanPenilaianSKPDetailTableActive' // Nama di tiap tabel harus beda karena akan disimpan di session
    defaultOrder = 'upload_skp_detail_id' // orderBy
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            activeUuid: null,
            defaultSize: 10,
            rows: [],
            detail: null,
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
    dateParse = (input) =>{
        let res = "";
        if (input !== "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
      }
    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            uuid: this.props.uuid
        }
        console.log(query,"query");
        await this.detailDataTableBloc.fetchDetailRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                // this.state.inactiveUuid && this.inactiveData()
                // this.state.activeUuid &&this.activeData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    // inactiveData = async () => {
    //     await this.detailDataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    // }
    // activeData = async () => {
    //     await this.detailDataTableBloc.fetchActive({ uuid: this.state.activeUuid })
    // }

    componentDidMount() {
        this.setTokenAPI()

        this.detailDataTableBloc.detailRowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        detail: response.detail,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        // this.detailDataTableBloc.inactiveChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             this.setState({
        //                 loading: false,
        //                 success: true,
        //                 loadingTable: true,
        //                 inactiveUuid:null
        //             }, function () {
        //                 this.setTokenAPI()
        //             });
        //             break
        //         case apiResponse.ERROR:
        //             this.setState({
        //                 loading: false,
        //                 failed: true,
        //             });
        //             break
        //         default:
        //             break
        //     }
        // })
        // this.detailDataTableBloc.activeChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             this.setState({
        //                 loading: false,
        //                 success: true,
        //                 loadingTable: true,
        //                 activeUuid:null
        //             }, function () {
        //                 this.setTokenAPI()
        //             });
        //             break
        //         case apiResponse.ERROR:
        //             this.setState({
        //                 loading: false,
        //                 failed: true,
        //             });
        //             break
        //         default:
        //             break
        //     }
        // })
    }

    componentWillUnmount() {
        this.detailDataTableBloc.detailRowtableChannel?.unsubscribe()
        // this.detailDataTableBloc.inactiveChannel?.unsubscribe()
        // this.detailDataTableBloc.activeChannel?.unsubscribe()
    }

    columns = [
        // {
        //     key: "upload_skp_detail_nip",
        //     text: "NIP",
        //     sortable: true,
        // },
        {
            key: "upload_skp_detail_nama",
            text: "Pegawai",
            sortable: true,
            cell: record => {
                return (
                    <Fragment>
                        <b>{record.upload_skp_detail_nip}</b>
                        <br />{record.upload_skp_detail_nama}<br />
                        <br /><b>Unor Induk</b>
                        <br />{record.upload_skp_detail_skp_unor_induk}
                        <br /><b>Unor</b>
                        <br />{record.upload_skp_detail_skp_unor}
                        <br /><b>Jabatan</b>
                        <br />{record.upload_skp_detail_skp_jabatan}

                    </Fragment>
                )
            }
        },
        // {
        //     key: "upload_skp_detail_skp_unor_induk",
        //     text: "Unor Induk",
        //     sortable: true,
        // },
        // {
        //     key: "upload_skp_detail_skp_unor",
        //     text: "Unor",
        //     sortable: true,
        // },
        // {
        //     key: "upload_skp_detail_skp_jabatan",
        //     text: "Jabatan",
        //     sortable: true,
        // },
        {
            key: "upload_skp_detail_skp_hasil_kerja",
            text: "Hasil Kerja",
            sortable: true,
        },
        {
            key: "upload_skp_detail_skp_perilaku_kerja",
            text: "Perilaku Kerja",
            sortable: true,
        },
        {
            key: "upload_skp_detail_skp_hasil_akhir",
            text: "Hasil Akhir",
            sortable: true,
        },
        {
            key: "upload_skp_detail_skp_pegawai_atasan_nama",
            text: "Pegawai Atasan",
            sortable: true,
            cell: record => {
                return (
                    <Fragment>
                        <b>{record.upload_skp_detail_skp_pegawai_atasan_nip}</b>
                        <br />{record.upload_skp_detail_skp_pegawai_atasan_nama}<br />
                        <br /><b>Unor</b>
                        <br />{record.upload_skp_detail_skp_pegawai_atasan_unor}
                        <br /><b>Jabatan</b>
                        <br />{record.upload_skp_detail_skp_pegawai_atasan_jabatan}
                        <br /><b>Golongan Ruang</b>
                        <br />{record.upload_skp_detail_skp_pegawai_atasan_golru}
                    </Fragment>
                )
            }

        },
        {
            key: "upload_skp_detail_skp_waktu_dinilai",
            text: "Waktu Dinilai",
            sortable: true,
            cell: record => this.dateParse(record.upload_skp_detail_skp_waktu_dinilai)
        },
        // {
        //     key: "upload_skp_detail_skp_tahun_skp",
        //     text: "Tahun SKP",
        //     sortable: true,
        // },
        // {
        //     key: "upload_skp_detail_status",
        //     text: "Status",
        //     sortable: true,
        //     cell: record => (record.upload_skp_detail_status === 1) ? <label className="badge rounded-pill bg-soft-info font-size-12" >Aktif</label> : <label className="badge rounded-pill bg-soft-warning font-size-12" >Nonaktif</label>
        // },
        // {
        //     key: "action",
        //     text: "Action",
        //     className: "action",
        //     width: 120,
        //     sortable: false,
        //     align: 'center',
        //     cell: record => {
        //         const thisId = record.upload_skp_detail_uuid
        //         const status = record.upload_skp_detail_status
        //         return (
        //             <Fragment>
        //                     <span>
        //                         <button
        //                             className="btn btn-primary btn-sm"
        //                             id={"detail-" + thisId}
        //                             onClick={() => {
        //                                 this.setState({
        //                                     detailUuid: record.upload_skp_uuid
        //                                 })
        //                             }}
        //                             style={{
        //                                 marginRight: '2px',
        //                                 padding: '2px 5px'
        //                             }}>
        //                             <i className="uil-align-left"></i>
        //                         </button>

        //                         <Tooltip
        //                             style={{
        //                                 marginBottom: 2
        //                             }}
        //                             placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
        //                             toggle={() => {
        //                                 this.setState({
        //                                     ["detail" + thisId]: !this.state["detail" + thisId]
        //                                 })
        //                             }}
        //                         > Detail </Tooltip>
        //                     </span>
        //             </Fragment>
        //         );
        //     }
        // }
    ]
    render() {
        return (
            <>
                <Row className="mb-3">
                    <label className="col-md-2 col-form-label" >
                        Tanggal Upload
                    </label>
                    <Col md="4">
                        : {!this.state.detail?<Shimmer><div style={{width: 100, height: 15}}></div></Shimmer>:this.dateParse(this.state.detail?.upload_skp_create_date)}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <label className="col-md-2 col-form-label" >
                        Dok Upload
                    </label>
                    <Col md="4">
                        : {!this.state.detail?<Shimmer><div style={{width: 100, height: 15}}></div></Shimmer>:<a target={"_blank"} href={this.state.detail?.document?.documents_path}>Lihat Dokumen</a>}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <label className="col-md-2 col-form-label" >
                        Tahun
                    </label>
                    <Col md="4">
                        :  {!this.state.detail?<Shimmer><div style={{width: 100, height: 15}}></div></Shimmer>:this.state.detail?.upload_skp_year}
                    </Col>
                </Row>
                <hr/>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={`Apakah anda yakin akan mengubah status data ini?`}

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diubah"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diubah"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/laporan_penilaian_skp.html?detail&uuid=" + this.state.detailUuid} />
                    : null}
                {this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/laporan_penilaian_skp.html?update&uuid=" + this.state.updateUuid} />
                    : null}
            </>
        )
    }

}

export default DetailTableActiveComponent